import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-collective-product-dashboard',
  templateUrl: './collective-product-dashboard.component.html',
  styleUrls: ['./collective-product-dashboard.component.scss']
})
export class CollectiveProductDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
